import type { FC } from "react";

import {
  ACCORDION_DEFAULTS,
  type TAccordionProps,
} from "@/ui/components/data-display/Accordion/Accordion.config";
import {
  AccordionContent,
} from "@/ui/components/data-display/Accordion/AccordionContent";
import {
  AccordionItem,
} from "@/ui/components/data-display/Accordion/AccordionItem";
import {
  AccordionRoot,
} from "@/ui/components/data-display/Accordion/AccordionRoot";
import {
  AccordionTrigger,
} from "@/ui/components/data-display/Accordion/AccordionTrigger";
import { cn } from "@/ui/lib/utils";

export const Accordion: FC<TAccordionProps> = (
  {
    className,
    collapsible = ACCORDION_DEFAULTS.collapsible,
    contentClassName,
    items,
    triggerClassName,
    type = ACCORDION_DEFAULTS.type,
    ...props
  },
) => (
  <AccordionRoot
    data-component="Accordion"
    className={cn(
      "w-full flex flex-col gap-2",
      className,
    )}
    type={type}
    collapsible={collapsible}
    {...props}
  >
    { items.map((item) => (
      <AccordionItem
        key={item.value}
        value={item.value}
        disabled={item.disabled}
      >
        <AccordionTrigger className={triggerClassName}>
          { item.label }
        </AccordionTrigger>
        <AccordionContent className={contentClassName}>
          { item.content }
        </AccordionContent>
      </AccordionItem>
    )) }
  </AccordionRoot>
);

Accordion.displayName = "Accordion";
